import { Link } from "@mui/material";
import { Link as RouterLink, useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { ROUTE_PARAMS } from "@/constants";
import type { DeviceFieldsFragment } from "@/gql/graphql";
import { getDeviceFilterSearch } from "@/components/Devices/deviceFilterSearch";

type DeviceIdentity = Pick<DeviceFieldsFragment, "serialNumber" | "modelName">;

type DeviceSerialLinkProps = {
  device: DeviceIdentity;
};

const DeviceSerialLink = ({ device }: DeviceSerialLinkProps) => {
  const { t } = useTranslation();
  const { [ROUTE_PARAMS.ACCOUNT_ID]: accountId } = useParams();

  if (device.modelName === null || accountId === undefined) {
    return null;
  }

  return (
    <Link
      component={RouterLink}
      style={{ display: "block", fontSize: "12px" }}
      state={{ resetDeviceTab: true, dismissDialogs: true }}
      to={{
        pathname: `/${accountId}/devices`,
        search: getDeviceFilterSearch(device),
      }}
    >
      {t("devices.view_device")}
    </Link>
  );
};

export default DeviceSerialLink;

const isDeviceIdentity = (value: unknown): value is DeviceIdentity => {
  if (typeof value !== "object" || value === null) {
    return false;
  }

  if (!("serialNumber" in value) || !("modelName" in value)) {
    return false;
  }

  return (
    typeof value.serialNumber === "string" &&
    (typeof value.modelName === "string" || value.modelName === null)
  );
};

export { isDeviceIdentity };
export type { DeviceIdentity };
